// View to manage the fields of a definition
//
// callbacks:
//
//  * `top_field_add`: Called when the user wants to add a field to the top
//  * `top_field_drop`: Called when the user drops a field in the top spot
var DefinitionFieldsV = function(core, $container){
    var _$topInsertionPoint = $container.find("li.field-insertion-point:first-child");

    return {
        init: function(callbacks){
            _$topInsertionPoint.on('click', callbacks.top_field_add);
            _$topInsertionPoint.droppable({
                //class added to the element while something is beeing dragged
                activeClass: 'def-state-active',

                //class added to the elemente while something is hovering above it
                hoverClass: 'def-state-hover',

                // don't add the dropped element to parent droppables
                greedy: true,

                // called when the element is actually dropped
                drop: function(event, ui) {
                    var _$draggedElement = ui.draggable;
                    //para a li voltar à lista e não ficar com o offset do fim do drag
                    _$draggedElement.attr('style', 'position:relative;');

                    callbacks.top_field_drop(_$draggedElement);
                }
            });
        },

        setReadonly: function() {
            // todo huma - this should be done in the template, but for now I will leave it here
            $container.find("input[type='text']").attr("readonly", "readonly");
            $container.find("input[type='checkbox']").attr("disabled", "disabled");
            $container.find(".remove-button, .field-insertion-point").addClass("invisible");
            $container.find(".condition-insertion-point").addClass("hidden");
        },

        addTopField: function(fieldP){
            _$topInsertionPoint.after(fieldP.content());

            fieldP.focus();
        },

        addBottomField: function(fieldP) {
            $container.append(fieldP.content());
        }
    }
};

export default DefinitionFieldsV;
